// The work window — how long a job needs, in hours.
//
// The console already has one shared playhead (time/cursor.ts). This is the other
// half of the same idea: the playhead says WHEN the window opens, this says how
// long it stays open. Together they are a DAW's loop region — a start you place
// and a length you set — which is why the ruler can draw the span rather than
// leaving "12 h" as a number in a panel that nothing on the timeline corroborates.
//
// Kept separate from cursor.ts on purpose. The cursor changes on every scrub; the
// length changes when someone decides a different job. Subscribers to one should
// not be woken by the other.

type Listener = (h: number) => void;

const DEFAULT_HOURS = 12;

let hours = DEFAULT_HOURS;
const listeners = new Set<Listener>();

/** The work window's length in hours. */
export function getWindowHours(): number {
  return hours;
}

/** Set the window length. No-ops when unchanged, like setCursor. */
export function setWindowHours(h: number): void {
  const next = Number.isFinite(h) && h > 0 ? h : DEFAULT_HOURS;
  if (next === hours) return;
  hours = next;
  for (const fn of [...listeners]) fn(hours);
}

/** Subscribe to window-length changes. Returns the unsubscribe. */
export function subscribeWindow(fn: Listener): () => void {
  listeners.add(fn);
  return () => {
    listeners.delete(fn);
  };
}
